import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const copiableCellClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.lg,
});
